module.exports = __webpack_public_path__ + "static/media/pressure.b04f1db3.svg";